import { addDays, addHours, addMonths, addSeconds, addYears, format, parse, parseISO, } from 'date-fns';
export const dateToNumber = (date) => {
    return new Date(date ?? '1970').getTime() / 1000;
};
export const dateToNumberOrUndefined = (date) => {
    return date ? dateToNumber(date) : undefined;
};
export const dateStringToFormattedDate = (dateString, opts) => {
    const { dateFormat } = opts ?? {};
    return format(Date.parse(dateString), dateFormat ?? 'dd/MM/yyyy HH:mm:ss');
};
export const dateToFormattedString = (date, opts) => {
    const { dateFormat } = opts ?? {};
    return format(date, dateFormat ?? 'dd/MM/yyyy HH:mm:ss');
};
export const dateStringToDate = (dateString, opts) => {
    const { isISO, format: formatStr } = opts ?? {};
    if (isISO) {
        return parseISO(dateString);
    }
    return parse(dateString, formatStr ?? 'dd/MM/yyyy HH:mm:ss', new Date());
};
export const addSecondsToDate = (date, seconds) => {
    return addSeconds(date, seconds);
};
export const addHoursToDate = (date, hours) => {
    return addHours(date, hours);
};
export const addDaysToDate = (date, days) => {
    return addDays(date, days);
};
export const addMonthsToDate = (date, months) => {
    return addMonths(date, months);
};
export const addYearsToDate = (date, years) => {
    return addYears(date, years);
};
export const isEasterSeason = () => {
    const currentDate = new Date();
    /**
     * IMPORTANT:
     * Easter dates change every year.
     * These dates are set for 2026 (Netherlands / Europe).
     * Please update them yearly.
     *
     * 2026 Easter:
     * - Good Friday: April 3
     * - Easter Sunday: April 5
     * - Easter Monday: April 6
     *
     * Active UI range:
     * March 25 – April 7
     */
    const easterStartDate = new Date(2026, 2, 25); // March 25, 2026
    const easterEndDate = new Date(2026, 3, 7); // April 7, 2026
    return currentDate >= easterStartDate && currentDate <= easterEndDate;
};
export const isChristmasSeason = () => {
    const now = new Date();
    const month = now.getMonth(); // 0 = Jan, ..., 10 = Nov, 11 = Dec
    const day = now.getDate();
    const isLateNovember = month === 10 && day >= 26;
    const isDecember = month === 11;
    const isEarlyJanuary = month === 0 && day <= 6;
    return isLateNovember || isDecember || isEarlyJanuary;
};
export const getSeasonalVariant = () => {
    if (isChristmasSeason()) {
        return 'christmas';
    }
    if (isEasterSeason()) {
        return 'easter';
    }
    return 'default';
};
export const Days = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
};
export const getDayName = (day) => {
    switch (day) {
        case Days.Sunday:
            return 'Sunday';
        case Days.Monday:
            return 'Monday';
        case Days.Tuesday:
            return 'Tuesday';
        case Days.Wednesday:
            return 'Wednesday';
        case Days.Thursday:
            return 'Thursday';
        case Days.Friday:
            return 'Friday';
        case Days.Saturday:
            return 'Saturday';
        default:
            throw new Error(`Invalid day: ${day}`);
    }
};
export const isOneOfDays = (date, ...days) => {
    if (days.length === 0) {
        return false;
    }
    return days.some((day) => day === date.getDay());
};
export const Months = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
};
//# sourceMappingURL=dates.js.map